$(document).ready(function() {

    /* ======================
       SHOP BY CATEGORIES (6 items)
    ====================== */
    var $shopSlider = $('.shop_by_categories .category-slider');

    $shopSlider.slick({
        autoplay: true,
        autoplaySpeed: 1000,
        speed: 1000,
        slidesToShow: 6,
        slidesToScroll: 1,
        arrows: false,
        pauseOnHover:false,
        pauseOnFocus: false,
        dots: false,
        infinite: true,
        responsive: [
            { breakpoint: 1200, settings: { slidesToShow: 5 } },
            { breakpoint: 1025, settings: { slidesToShow: 4 } },
            { breakpoint: 768, settings: { slidesToShow: 3 } },
            { breakpoint: 576, settings: { slidesToShow: 2 } },
            { breakpoint: 400, settings: { slidesToShow: 2 } }
        ]
    });

    $('.shop_by_categories .prev').click(function() {
        $shopSlider.slick('slickPrev');
    });
    $('.shop_by_categories .next').click(function() {
        $shopSlider.slick('slickNext');
    });

    $shopSlider.on('afterChange', function(event, slick, currentSlide) {
        var totalSlides = slick.slideCount - slick.options.slidesToShow;
        if (totalSlides < 1) totalSlides = 1;
        var progress = (currentSlide / totalSlides) * 100;
        $('.shop_by_categories .progress').css('width', progress + '%');
    });

    $shopSlider.trigger('afterChange', [$shopSlider.slick('getSlick'), 0]);



    /* ======================
       GET INSPIRED (3 items)
    ====================== */
    var $inspiredSlider = $('.get_inspired .category-slider');

    $inspiredSlider.slick({
        autoplay: true,
        autoplaySpeed: 1000,
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: true,
        pauseOnHover:false,
        pauseOnFocus: false,
        centerMode: false,
        variableWidth: true,
        responsive: [
            { breakpoint: 1200, settings: { slidesToShow: 3 } },
            { breakpoint: 992, settings: { slidesToShow: 3 } },
            { breakpoint: 810, settings: { slidesToShow: 1, variableWidth: false, } },
            { breakpoint: 576, settings: { slidesToShow: 1,variableWidth: false,adaptiveHeight: true, } }
        ]
    });

    $('.get_inspired .prev').click(function() {
        $inspiredSlider.slick('slickPrev');
    });
    $('.get_inspired .next').click(function() {
        $inspiredSlider.slick('slickNext');
    });

    $inspiredSlider.on('afterChange', function(event, slick, currentSlide) {
        var totalSlides = slick.slideCount - slick.options.slidesToShow;
        if (totalSlides < 1) totalSlides = 1;
        var progress = (currentSlide / totalSlides) * 100;
        $('.get_inspired .progress').css('width', progress + '%');
    });

    $inspiredSlider.trigger('afterChange', [$inspiredSlider.slick('getSlick'), 0]);


    /* ======================
     Blog Post
  ====================== */
    var $post_slider = $('.latest-blog-posts .blog-posts-grid');

    $post_slider.slick({
        autoplay: true,
        autoplaySpeed: 1000,
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: true,
        pauseOnHover:false,
        pauseOnFocus: false,
        responsive: [
            { breakpoint: 1200, settings: { slidesToShow: 3 } },
            { breakpoint: 992, settings: { slidesToShow: 2 } },
            { breakpoint: 768, settings: { slidesToShow: 2 } },
            { breakpoint: 577, settings: { slidesToShow: 1 } }
        ]
    });

    $('.latest-blog-posts .prev').click(function() {
        $post_slider.slick('slickPrev');
    });
    $('.latest-blog-posts .next').click(function() {
        $post_slider.slick('slickNext');
    });

    $post_slider.on('afterChange', function(event, slick, currentSlide) {
        var totalSlides = slick.slideCount - slick.options.slidesToShow;
        if (totalSlides < 1) totalSlides = 1;
        var progress = (currentSlide / totalSlides) * 100;
        $('.latest-blog-posts .progress').css('width', progress + '%');
    });

    $post_slider.trigger('afterChange', [$post_slider.slick('getSlick'), 0]);

});


$(document).ready(function(){
  var $carousel = $('.image-with-content-slide .carousel');
  
  $carousel.slick({
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 700,
    fade: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: false,
    pauseOnFocus: false,
    swipe: true,
    touchMove: true
  });

  // Custom arrows
  $('.custom-left-arrow').click(function(){
    $carousel.slick('slickPrev');
  });
  $('.custom-right-arrow').click(function(){
    $carousel.slick('slickNext');
  });

  // Update index text
  $carousel.on('afterChange', function(event, slick, currentSlide){
    $('.image-with-content-slide .index').text(currentSlide + 1);
  });

  // Mobile autoplay force fix
  $(document).on('touchstart click', function() {
    $carousel.slick('slickPlay');  
  });
});



//
jQuery(document).ready(function($2) {
    function isInViewport(elem) {
        const elementTop = $2(elem).offset().top;
        const elementBottom = elementTop + $2(elem).outerHeight();
        const viewportTop = $2(window).scrollTop();
        const viewportBottom = viewportTop + $2(window).height();
        return elementBottom > viewportTop && elementTop < viewportBottom;
    }

    function checkAboutImageAnimation() {
        $2(".left-image__img , .animate-second , .animate-first,.animate-first img ").each(function() {
            if (isInViewport(this)) {
                $2(this).addClass("animate");
            } else {
                $2(this).removeClass("animate");
            }
        });
    }

    checkAboutImageAnimation();
    $2(window).on("scroll resize", checkAboutImageAnimation);
});

document.addEventListener("DOMContentLoaded", function () {
    ScrollReveal().reveal(
        ".reveal , .shopify-policy__container h2 , .shopify-policy__container p , .shopify-policy__container ul li",
        {
            delay: 200,
            distance: "50px",
            origin: "bottom",
            duration: 1000,
            easing: "ease-in-out",
            interval: 100,
            reset: true
        }
    );
});

ScrollReveal().reveal(".reveal-bottom,.ui-test-product-list:has(> .home_products) h3", {
    origin: "bottom",
    distance: "50px",
    duration: 1000,
    reset: true
});

ScrollReveal().reveal(
  "#MainContent #ResultsList ul li,.shopify-section .resource-list__item",
  {
    delay: 20,
    duration: 500,
    distance: "0px",
    opacity: 0,
    scale: 0.97,
    easing: "ease-in-out",
    reset: false,
    interval: 80,

  }
);

document.querySelectorAll(".category-image img,.custom-image-multiple-products .product-image img")
  .forEach(img => {
    const revealOptions = {
      delay: 20,
        duration: 500,
        distance: "0px",
        opacity: 0,
        scale: 0.97,
        easing: "ease-in-out",
        interval: 80,
        reset: true
    };

    if (img.complete && img.naturalHeight !== 0) {
      ScrollReveal().reveal(img, revealOptions);
    } else {
      img.addEventListener("load", () => {
        ScrollReveal().reveal(img, revealOptions);
      });
    }
  });


document.addEventListener("DOMContentLoaded", function () {
    ScrollReveal().reveal(
        ".reveal , .shopify-policy__container h2 , .shopify-policy__container p , .shopify-policy__container ul li",
        {
            delay: 200,
            distance: "50px",
            origin: "bottom",
            duration: 1000,
            easing: "ease-in-out",
            interval: 100,
            reset: true
        }
    );
});

const sr = ScrollReveal({
  duration: 900,
  distance: "40px",
  easing: "ease-out",
  opacity: 0,
  mobile: true,
  reset: false 
});

// 1st Item → Bottom Fade
sr.reveal(".icon-with-content__wrapper .icon-with-content__item:nth-child(1)", {
  origin: "bottom",
  interval: 120
});

// 2nd Item → Zoom In
sr.reveal(".icon-with-content__wrapper .icon-with-content__item:nth-child(2)", {
  scale: 0.85,
  interval: 120
});

// 3rd Item → Rotate Slight + Fade
sr.reveal(".icon-with-content__wrapper .icon-with-content__item:nth-child(3)", {
  rotate: { x: 0, y: 20, z: 0 },
  interval: 120
});

// 4th Item → Slide From Top
sr.reveal(".icon-with-content__wrapper .icon-with-content__item:nth-child(4)", {
  origin: "top",
  distance: "60px",
  interval: 120
});

// 5th Item → Flip/Rotate Effect
sr.reveal(".icon-with-content__wrapper .icon-with-content__item:nth-child(5)", {
  rotate: { x: 90, y: 0, z: 0 },
  scale: 0.9,
  interval: 120
});


document.addEventListener("DOMContentLoaded", function () {
  function updateSku(picker, variantId) {
    const sectionId = picker.dataset.sectionId;
    const skuEl = document.getElementById(`ProductSku-${sectionId}`);
    if (!skuEl) return;

    const jsonEl = picker.querySelector('script[type="application/json"]');
    let variantData = null;
    if (jsonEl) {
      try {
        variantData = JSON.parse(jsonEl.textContent);
      } catch (e) {
        console.warn("JSON parse error", e);
      }
    }

    if (variantData && String(variantData.id) === String(variantId)) {
      skuEl.textContent = variantData.sku || skuEl.getAttribute("data-fallback") || "N/A";
    } else {
      setTimeout(() => updateSku(picker, variantId), 100);
    }

    console.log("🎯 Variant ID:", variantId, "→ SKU:", variantData ? variantData.sku : "waiting...");
  }

  // Default load
  document.querySelectorAll("variant-picker").forEach(picker => {
    const checked = picker.querySelector('input[type="radio"][data-variant-id]:checked');
    if (checked) {
      updateSku(picker, checked.getAttribute("data-variant-id"));
    }
  });

  // On change
  document.querySelectorAll('variant-picker input[type="radio"][data-variant-id]').forEach(input => {
    input.addEventListener("change", function () {
      const picker = this.closest("variant-picker");
      if (!picker) return;
      const variantId = this.getAttribute("data-variant-id");
      updateSku(picker, variantId);
    });
  });
});


$(document).ready(function () {
  $("accordion-custom").each(function () {
    let table = $(this).find(".product_shop_attributes");

    if (table.length === 0) return;

    let rows = table.find("tbody tr");

    if (
      rows.length === 0 ||
      (rows.length === 1 && rows.find("p").text().trim() === "Default Title")
    ) {
      $(this).addClass("accordion-empty");
    }
  });
});


document.addEventListener('DOMContentLoaded', function () {
  const productGrid = document.querySelector('.product-grid');
  if (!productGrid) return;
  if (window.innerWidth < 1024) return;

  const scrollToGrid = () => {
    const gridTop = productGrid.getBoundingClientRect().top + window.scrollY - 20;
    window.scrollTo({ top: gridTop, behavior: 'smooth' });
  };

  let lastHTML = productGrid.innerHTML;

  const observer = new MutationObserver(function () {
    const currentHTML = productGrid.innerHTML;

    if (currentHTML !== lastHTML) {
      lastHTML = currentHTML;

      // Only scroll if a filter param exists in URL
      if (window.location.search.includes('filter.p.tag')) {
        setTimeout(scrollToGrid, 150);
      }
    }
  });

  observer.observe(productGrid, { childList: true, subtree: true });

  // Initial scroll on page load if filter is present
  if (window.location.search.includes('filter.p.tag')) {
    setTimeout(scrollToGrid, 200);
  }
});




document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".prodyct_accrodian .accordion--caret p").forEach(function (p) {
    if (p && p.innerHTML && p.innerHTML.trim() === "&nbsp;") {
      p.remove();
    }
  });
});

$(document).ready(function() {
  // Left Banner Slick Slider with Animation
  $('.Main_banner .left_banner.category-slider').slick({
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: true,
    fade: true, // fade animation
    pauseOnHover: false,
    pauseOnFocus: false,
    cssEase: 'ease-in-out',
  });

  // Animation effect on slide change
  $('.Main_banner .left_banner.category-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    let $current = $(slick.$slides[nextSlide]);
    $current.find('img').addClass('zoom-in');
    setTimeout(function() {
      $current.find('img').removeClass('zoom-in');
    }, 1000);
  });
});



